import { PlayButtonSize as a } from "./components/BrightcovePlayer/types/enums.js";
import './assets/propTypes.css';const o = "#ffffff", e = "#396e75", n = "#e5fdff", r = "#546223", l = "#f0fae5", i = "#a65523", d = "#fff1e8", c = "#7f3e3e", z = "#ffe2e2", u = "#62625a", g = "#f8f8e7", s = "#38539a", b = "#707070", m = "#c8f8d1", y = "#87c9c8", V = "#5291b1", S = "rgba(82, 145, 177, 0.1019607843)", C = "#445685", P = "#181d61", f = "rgba(24, 29, 97, 0.1019607843)", h = "#5969d6", k = "#ea999d", p = "#b6577e", B = "rgba(182, 87, 126, 0.1019607843)", _ = "#7e3e80", F = "#1e247f", M = "rgba(30, 36, 127, 0.1019607843)", G = "#da7600", w = "#107f47", O = "#d91734", v = "5rem", R = "revert-layer", W = "inherit", j = "3rem", A = "-1.5rem", Y = "2rem", L = "1.75rem", E = "1rem", x = "_html_13ej5_34", t = {
  amwayWhite: o,
  darkBlue: e,
  lightBlue: n,
  darkGreen: r,
  lightGreen: l,
  darkOrange: i,
  lightOrange: d,
  darkRed: c,
  lightRed: z,
  darkYellow: u,
  lightYellow: g,
  darkPurple: s,
  darkGrayOnWhite: b,
  dataVizColor1: m,
  dataVizColor2: y,
  dataVizColor3: V,
  dataVizColor3Background: S,
  dataVizColor4: C,
  dataVizColor5: P,
  dataVizColor5Background: f,
  dataVizColor6: h,
  dataVizColor7: k,
  dataVizColor8: p,
  dataVizColor8Background: B,
  dataVizColor9: _,
  dataVizColor10: F,
  dataVizColor10Background: M,
  dataVizAlertOrange: G,
  dataVizSuccessGreen: w,
  dataVizWarningRed: O,
  largePlaybuttonSize: v,
  largePlaybuttonMargin: R,
  largePlaybuttonFontSize: W,
  mediumPlaybuttonSize: j,
  mediumPlaybuttonMargin: A,
  mediumPlaybuttonFontSize: Y,
  smallPlaybuttonSize: L,
  smallPlaybuttonFontSize: E,
  html: x,
  "brightcove-player-container": "_brightcove-player-container_13ej5_68",
  "brightcove-player-duration-tag": "_brightcove-player-duration-tag_13ej5_71",
  "brightcove-wrapper-play-button": "_brightcove-wrapper-play-button_13ej5_77"
}, I = {
  [a.LARGE]: {
    buttonSize: t.largePlaybuttonSize,
    margin: t.largePlaybuttonMargin,
    fontSize: t.largePlaybuttonFontSize
  },
  [a.MEDIUM]: {
    buttonSize: t.mediumPlaybuttonSize,
    margin: t.mediumPlaybuttonMargin,
    fontSize: t.mediumPlaybuttonFontSize
  },
  [a.SMALL]: {
    buttonSize: t.smallPlaybuttonSize,
    margin: `-${t.smallPlaybuttonFontSize}`,
    fontSize: t.smallPlaybuttonFontSize
  }
};
export {
  I as b,
  t as s
};
//# sourceMappingURL=propTypes-40cb8a9c.mjs.map
